var map = {
	"./404-bg": 319,
	"./404-bg.png": 319,
	"./404-img-1": 320,
	"./404-img-1.png": 320,
	"./404-img-2": 321,
	"./404-img-2.png": 321,
	"./404-img-3": 322,
	"./404-img-3.png": 322,
	"./banner": 323,
	"./banner-bg": 324,
	"./banner-bg.jpg": 324,
	"./banner.svg": 323,
	"./bg-finger-print": 325,
	"./bg-finger-print.png": 325,
	"./business-modelling/welcome": 261,
	"./business-modelling/welcome.jpg": 261,
	"./business-modelling/welcome@2x": 267,
	"./business-modelling/welcome@2x.jpg": 267,
	"./checkbox": 326,
	"./checkbox-green": 327,
	"./checkbox-green.svg": 327,
	"./checkbox-white": 328,
	"./checkbox-white.svg": 328,
	"./checkbox.svg": 326,
	"./checkmark": 329,
	"./checkmark.svg": 329,
	"./contact-img": 330,
	"./contact-img.jpg": 330,
	"./cost-recovery-bg": 331,
	"./cost-recovery-bg.png": 331,
	"./cost-to-serve-bg": 332,
	"./cost-to-serve-bg.png": 332,
	"./decision-maker-bg": 251,
	"./decision-maker-bg.png": 251,
	"./decision-maker-bg.webp": 616,
	"./disclaimer-bg": 333,
	"./disclaimer-bg.jpg": 333,
	"./feedback-bg": 334,
	"./feedback-bg.png": 334,
	"./fields": 335,
	"./fields.jpeg": 335,
	"./finger-print": 336,
	"./finger-print-green": 337,
	"./finger-print-green.png": 337,
	"./finger-print.png": 336,
	"./footer-logo": 338,
	"./footer-logo.svg": 338,
	"./guides-test-img": 339,
	"./guides-test-img.png": 339,
	"./guides-widget-bg": 340,
	"./guides-widget-bg.png": 340,
	"./home-logo-big": 341,
	"./home-logo-big.svg": 341,
	"./home-logo-small": 342,
	"./home-logo-small.svg": 342,
	"./icons/1-green": 343,
	"./icons/1-green.svg": 343,
	"./icons/1-white": 344,
	"./icons/1-white.svg": 344,
	"./icons/2-green": 345,
	"./icons/2-green.svg": 345,
	"./icons/2-white": 346,
	"./icons/2-white.svg": 346,
	"./icons/3-green": 347,
	"./icons/3-green.svg": 347,
	"./icons/add-circle-blue": 260,
	"./icons/add-circle-blue.svg": 260,
	"./icons/arrow-down": 348,
	"./icons/arrow-down-green": 349,
	"./icons/arrow-down-green.svg": 349,
	"./icons/arrow-down.svg": 348,
	"./icons/arrow-left": 350,
	"./icons/arrow-left-black": 258,
	"./icons/arrow-left-black.png": 258,
	"./icons/arrow-left.svg": 350,
	"./icons/arrow-lookup": 268,
	"./icons/arrow-lookup.svg": 268,
	"./icons/arrow-right-blue": 351,
	"./icons/arrow-right-blue.svg": 351,
	"./icons/arrow-right-green": 352,
	"./icons/arrow-right-green.svg": 352,
	"./icons/arrow-up": 353,
	"./icons/arrow-up.svg": 353,
	"./icons/beans": 354,
	"./icons/beans.svg": 354,
	"./icons/bm": 355,
	"./icons/bm.svg": 355,
	"./icons/building": 356,
	"./icons/building.svg": 356,
	"./icons/bullet": 357,
	"./icons/bullet.svg": 357,
	"./icons/button-arrow": 358,
	"./icons/button-arrow.svg": 358,
	"./icons/chart-blue": 269,
	"./icons/chart-blue.svg": 269,
	"./icons/chart-gray": 270,
	"./icons/chart-gray.png": 270,
	"./icons/check-circle-white": 271,
	"./icons/check-circle-white.png": 271,
	"./icons/close": 272,
	"./icons/close-circle-blue": 273,
	"./icons/close-circle-blue.svg": 273,
	"./icons/close-dark": 262,
	"./icons/close-dark.png": 262,
	"./icons/close-green": 359,
	"./icons/close-green.svg": 359,
	"./icons/close-white": 360,
	"./icons/close-white.svg": 360,
	"./icons/close.png": 272,
	"./icons/computer": 274,
	"./icons/computer.png": 274,
	"./icons/confidence-level-1": 361,
	"./icons/confidence-level-1.svg": 361,
	"./icons/confidence-level-2": 362,
	"./icons/confidence-level-2.svg": 362,
	"./icons/confidence-level-3": 363,
	"./icons/confidence-level-3.svg": 363,
	"./icons/confidence-level-4": 364,
	"./icons/confidence-level-4.svg": 364,
	"./icons/confidence-level-5": 365,
	"./icons/confidence-level-5.svg": 365,
	"./icons/data-explorer": 366,
	"./icons/data-explorer.svg": 366,
	"./icons/download": 367,
	"./icons/download-file": 368,
	"./icons/download-file-green": 369,
	"./icons/download-file-green.svg": 369,
	"./icons/download-file.svg": 368,
	"./icons/download-page": 370,
	"./icons/download-page.svg": 370,
	"./icons/download.svg": 367,
	"./icons/editor-link": 371,
	"./icons/editor-link.svg": 371,
	"./icons/editor-unlink": 372,
	"./icons/editor-unlink.svg": 372,
	"./icons/email": 373,
	"./icons/email-outline": 374,
	"./icons/email-outline.svg": 374,
	"./icons/email.svg": 373,
	"./icons/facebook": 375,
	"./icons/facebook.svg": 375,
	"./icons/france": 376,
	"./icons/france.svg": 376,
	"./icons/glossary-icon": 377,
	"./icons/glossary-icon.svg": 377,
	"./icons/green-arrow-left": 378,
	"./icons/green-arrow-left.svg": 378,
	"./icons/green-arrow-right": 379,
	"./icons/green-arrow-right.svg": 379,
	"./icons/green-finger-print": 380,
	"./icons/green-finger-print.svg": 380,
	"./icons/help": 259,
	"./icons/help.png": 259,
	"./icons/home": 381,
	"./icons/home.svg": 381,
	"./icons/icon-blended-finance": 382,
	"./icons/icon-blended-finance.svg": 382,
	"./icons/icon-building": 383,
	"./icons/icon-building.svg": 383,
	"./icons/icon-bulb": 384,
	"./icons/icon-bulb.svg": 384,
	"./icons/icon-business-practices": 385,
	"./icons/icon-business-practices.svg": 385,
	"./icons/icon-buyer": 386,
	"./icons/icon-buyer.svg": 386,
	"./icons/icon-checkmark": 387,
	"./icons/icon-checkmark.svg": 387,
	"./icons/icon-farmer": 388,
	"./icons/icon-farmer.svg": 388,
	"./icons/icon-fertilizer": 389,
	"./icons/icon-fertilizer.svg": 389,
	"./icons/icon-heart": 390,
	"./icons/icon-heart.svg": 390,
	"./icons/icon-location-2": 391,
	"./icons/icon-location-2.svg": 391,
	"./icons/icon-monitoring": 392,
	"./icons/icon-monitoring.svg": 392,
	"./icons/icon-progress": 393,
	"./icons/icon-progress.svg": 393,
	"./icons/icon-replanting": 394,
	"./icons/icon-replanting.svg": 394,
	"./icons/icon-reporting": 395,
	"./icons/icon-reporting.svg": 395,
	"./icons/icon-retail": 396,
	"./icons/icon-retail.svg": 396,
	"./icons/icon-tools": 397,
	"./icons/icon-tools.svg": 397,
	"./icons/icon-warning": 398,
	"./icons/icon-warning.svg": 398,
	"./icons/idc": 399,
	"./icons/idc.svg": 399,
	"./icons/info": 400,
	"./icons/info.svg": 400,
	"./icons/innovations/business": 401,
	"./icons/innovations/business.svg": 401,
	"./icons/innovations/cost": 402,
	"./icons/innovations/cost-o30": 403,
	"./icons/innovations/cost-o30.svg": 403,
	"./icons/innovations/cost.svg": 402,
	"./icons/innovations/farmer": 404,
	"./icons/innovations/farmer.svg": 404,
	"./icons/innovations/feedback": 405,
	"./icons/innovations/feedback.svg": 405,
	"./icons/innovations/level-green-high": 406,
	"./icons/innovations/level-green-high.svg": 406,
	"./icons/innovations/level-green-low": 407,
	"./icons/innovations/level-green-low.svg": 407,
	"./icons/innovations/level-green-medium": 408,
	"./icons/innovations/level-green-medium.svg": 408,
	"./icons/innovations/level-high": 409,
	"./icons/innovations/level-high.svg": 409,
	"./icons/innovations/level-low": 410,
	"./icons/innovations/level-low.svg": 410,
	"./icons/innovations/level-medium": 411,
	"./icons/innovations/level-medium.svg": 411,
	"./icons/innovations/time": 412,
	"./icons/innovations/time-faded": 413,
	"./icons/innovations/time-faded.svg": 413,
	"./icons/innovations/time.svg": 412,
	"./icons/insights-explorer": 414,
	"./icons/insights-explorer.svg": 414,
	"./icons/instagram": 415,
	"./icons/instagram.svg": 415,
	"./icons/items-checklist-pebble-dark-green-rgb": 416,
	"./icons/items-checklist-pebble-dark-green-rgb.svg": 416,
	"./icons/items-money-pebble-dark-green-rgb": 417,
	"./icons/items-money-pebble-dark-green-rgb.svg": 417,
	"./icons/items-produce-pebble-dark-green-rgb": 418,
	"./icons/items-produce-pebble-dark-green-rgb.svg": 418,
	"./icons/items-tree-pebble-dark-green-rgb": 419,
	"./icons/items-tree-pebble-dark-green-rgb.svg": 419,
	"./icons/link": 263,
	"./icons/link-white": 275,
	"./icons/link-white.svg": 275,
	"./icons/link.svg": 263,
	"./icons/linkedin": 420,
	"./icons/linkedin.svg": 420,
	"./icons/location": 421,
	"./icons/location.svg": 421,
	"./icons/logo": 422,
	"./icons/logo-green": 276,
	"./icons/logo-green.png": 276,
	"./icons/logo.png": 422,
	"./icons/n-a": 252,
	"./icons/n-a.png": 252,
	"./icons/n-a.svg": 617,
	"./icons/pdf": 264,
	"./icons/pdf-white": 265,
	"./icons/pdf-white.svg": 265,
	"./icons/pdf.svg": 264,
	"./icons/picker-shape": 423,
	"./icons/picker-shape.svg": 423,
	"./icons/play-button": 424,
	"./icons/play-button-large": 425,
	"./icons/play-button-large.svg": 425,
	"./icons/play-button.svg": 424,
	"./icons/positive-trend": 426,
	"./icons/positive-trend.svg": 426,
	"./icons/print": 427,
	"./icons/print-white": 428,
	"./icons/print-white.svg": 428,
	"./icons/print.svg": 427,
	"./icons/quote": 429,
	"./icons/quote-large": 430,
	"./icons/quote-large.svg": 430,
	"./icons/quote.svg": 429,
	"./icons/search": 431,
	"./icons/search.svg": 431,
	"./icons/share": 432,
	"./icons/share.svg": 432,
	"./icons/sidebar-step": 433,
	"./icons/sidebar-step.svg": 433,
	"./icons/simple-arrow-down": 434,
	"./icons/simple-arrow-down.svg": 434,
	"./icons/soundcloud": 435,
	"./icons/soundcloud.svg": 435,
	"./icons/spain": 436,
	"./icons/spain.svg": 436,
	"./icons/strong-relationship": 437,
	"./icons/strong-relationship.svg": 437,
	"./icons/test-pic": 438,
	"./icons/test-pic.svg": 438,
	"./icons/toc": 439,
	"./icons/toc.svg": 439,
	"./icons/topics-action-pebble-dark-green-rgb": 440,
	"./icons/topics-action-pebble-dark-green-rgb.svg": 440,
	"./icons/topics-climate-change-pebble-dark-green-rgb": 441,
	"./icons/topics-climate-change-pebble-dark-green-rgb.svg": 441,
	"./icons/topics-consumer-pebble-dark-green-rgb": 442,
	"./icons/topics-consumer-pebble-dark-green-rgb.svg": 442,
	"./icons/topics-environment-pebble-dark-green-rgb": 443,
	"./icons/topics-environment-pebble-dark-green-rgb.svg": 443,
	"./icons/topics-food-waste-pebble-dark-green-rgb": 444,
	"./icons/topics-food-waste-pebble-dark-green-rgb.svg": 444,
	"./icons/topics-improved-field-level-sustainability-pebble-dark-green-rgb": 445,
	"./icons/topics-improved-field-level-sustainability-pebble-dark-green-rgb.svg": 445,
	"./icons/topics-living-wage-pebble-dark-green-rgb": 446,
	"./icons/topics-living-wage-pebble-dark-green-rgb.svg": 446,
	"./icons/topics-partnerships-pebble-dark-green-rgb": 447,
	"./icons/topics-partnerships-pebble-dark-green-rgb.svg": 447,
	"./icons/topics-processing-pebble-dark-green-rgb": 448,
	"./icons/topics-processing-pebble-dark-green-rgb.svg": 448,
	"./icons/topics-water-efficiency-pebble-dark-green-rgb": 449,
	"./icons/topics-water-efficiency-pebble-dark-green-rgb.svg": 449,
	"./icons/trending": 450,
	"./icons/trending.svg": 450,
	"./icons/twitter": 451,
	"./icons/twitter.svg": 451,
	"./icons/united-kingdom": 452,
	"./icons/united-kingdom.svg": 452,
	"./icons/values-integrity-pebble-dark-green-rgb": 453,
	"./icons/values-integrity-pebble-dark-green-rgb.svg": 453,
	"./icons/weak-relationship": 454,
	"./icons/weak-relationship.svg": 454,
	"./icons/white-bullet": 455,
	"./icons/white-bullet.svg": 455,
	"./icons/wiki-crumbs-arrow": 456,
	"./icons/wiki-crumbs-arrow.svg": 456,
	"./icons/wiki-search": 457,
	"./icons/wiki-search.svg": 457,
	"./icons/wiki-third-level-branch": 458,
	"./icons/wiki-third-level-branch-last": 459,
	"./icons/wiki-third-level-branch-last.svg": 459,
	"./icons/wiki-third-level-branch.svg": 458,
	"./icons/youtube": 460,
	"./icons/youtube.svg": 460,
	"./insights-img": 461,
	"./insights-img.png": 461,
	"./logo": 462,
	"./logo-green": 463,
	"./logo-green.svg": 463,
	"./logo.svg": 462,
	"./n-a": 464,
	"./n-a.jpg": 464,
	"./newsletter-bg": 465,
	"./newsletter-bg.jpg": 465,
	"./page-content-bg": 466,
	"./page-content-bg.jpg": 466,
	"./paradigm-bg": 253,
	"./paradigm-bg.jpg": 253,
	"./paradigm-bg.webp": 618,
	"./placeholder": 277,
	"./placeholder.png": 277,
	"./playbook-blue-card-bg": 467,
	"./playbook-blue-card-bg.png": 467,
	"./playbook-green-card-bg": 468,
	"./playbook-green-card-bg.png": 468,
	"./playbook-hero-bg": 254,
	"./playbook-hero-bg.jpg": 254,
	"./playbook-hero-bg.webp": 619,
	"./playbook-yellow-card-bg": 469,
	"./playbook-yellow-card-bg.png": 469,
	"./practitioner-bg": 255,
	"./practitioner-bg.png": 255,
	"./practitioner-bg.webp": 620,
	"./research-analyst-bg": 256,
	"./research-analyst-bg.png": 256,
	"./research-analyst-bg.webp": 621,
	"./subscribe-pg": 470,
	"./subscribe-pg.png": 470,
	"./test-pic": 471,
	"./test-pic.png": 471,
	"./value-created-bg": 472,
	"./value-created-bg.png": 472
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 250;